/**
 * Default: Modules > Jobs > Filter
 *
 * @copyright 2025 i-fabrik GmbH
 * @author Tobias Garz
 */

import SelectorEngine from '../../../shared/dom/selector-engine';
import Data           from '../../../shared/dom/data';
import Slider         from '../../../shared/components/slider';
import EventHandler from '../../../shared/dom/event-handler';
import Manipulator from '../../../shared/dom/manipulator';

// -------
// Private
// -------

const NAME      = 'jobs';
const CONTAINER = SelectorEngine.findOne(`.${NAME}-group`);

const initSorting = () => {
	const SELECT_SORTING = SelectorEngine.findOne(`[data-filter="sorting"][data-target]`, CONTAINER);

	if(!SELECT_SORTING) return;

	EventHandler.on(SELECT_SORTING, 'change', (event) => {
		let selectTarget = Manipulator.getDataAttribute(SELECT_SORTING, 'target') ? SelectorEngine.findOne(`#${Manipulator.getDataAttribute(SELECT_SORTING, 'target')}`) : null;

		if(!selectTarget) return;

		let formTarget         = SelectorEngine.parents(selectTarget, '.form')[0];
		selectTarget.value = SELECT_SORTING.value;

		if(formTarget) {
			formTarget.submit();
		}
	});
};

// -------
// Public
// -------

/**
 * init News Filter
 */
const init = () => {
	if(!CONTAINER) return;

	initSorting();
};

// Execute
init();
